// import TweenLite from './vendor/TweenLite';
import Preloader from "./preloader"
import Intro from "./intro"
import ProgressBar from "./progress-bar";
import Question from "./question"
import Results from "./results"
import Overlay from "./overlay"
import { makeXhrRequest } from "./utilities/index"

let Application = function (params) {
	if (Application.prototype._singletonInstance) {
		return Application.prototype._singletonInstance
	}
	Application.prototype._singletonInstance = this

	this.initialize(params)
}

Application.prototype.initialize = function (params) {
	// console.log('Application initalizing ' + params);

	Application.tweenLength = 0.5
	Application.tweenStagger = "-=0.25"

	/**
	 *
	 */
	let self = this
	this.preloader = new Preloader({})
	this.overlay = new Overlay()
	this.intro = new Intro({})
	this.question1 = new Question({ elementId: "question-1" })
	this.question2 = new Question({ elementId: "question-2" })
	this.question3 = new Question({ elementId: "question-3" })
	this.question4 = new Question({ elementId: "question-4" })
	this.question5 = new Question({ elementId: "question-5" })
	this.question6 = new Question({ elementId: "question-6" })
	this.question7 = new Question({ elementId: "question-7" })
	this.question8 = new Question({ elementId: "question-8" })
	this.question9 = new Question({ elementId: "question-9" })
	/*
	this.question10 = new Question({ elementId: "question-10" })
	*/
	
	this.questions = [this.question1, this.question2, this.question3, this.question4, this.question5, this.question6, this.question7, this.question8, this.question9 ]
	this.results = new Results({})

	this.progressBar = new ProgressBar();
	this.progressBar.hide();
	this.progressBarSegments = document.querySelectorAll('.progress-bar');

	this.progressBar.onBackButtonClick = function () {
		self.questions[self.currentQuestion - 1].previousClicked();
	};

	// Current screen/state info
	// preloader, intro, question, results
	this.currentState = "preloader"
	this.currentQuestion = 0
	this.totalQuestions = this.questions.length
	// this.totalQuestions = 1; // for testing results faster

	this.progressIndex = 0


	this.questionScores = {};

	this.answers = {
		distance: 0,
		trajectory: 0,
		performance: 0,
		tempo: 0,
		loft: 0,
		handedness: ''
	};

	this.matrix = [

		{
			id: "GT1",
			fiId: 4607,
			min: 1,
			max: 10
		},
		{
			id: "GTS2",
			fiId: 4692,
			min: 11,
			max: 25
		},
		{
			id: "GTS3",
			fiId: 4693,
			min: 26,
			max: 40
		},
		{
			id: "GTS4",
			fiId: 4694,
			min: 41,
			max: 50
		}
	]

	this.shaftMatrix =
	{
		"GT1": [
			{
				"shaft": "Fuji35",
				"flexes": [{"name": "R3", "value": 1 }]
			},
			{
				"shaft": "Fuji40",
				"flexes": [{ "name": "R2", "value": 2 }, { "name": "R", "value": 3 }, { "name": "S", "value": 4 }]
			},
			{
				"shaft": "ProjX40",
				"flexes": [{ "name": "4.0", "value": 1 }]
			},
			{
				"shaft": "ProjX50",
				"flexes": [{ "name": "5.0", "value": 2 }, { "name": "5.5", "value": 3 }, { "name": "6.0", "value": 4 }]
			},
			{
				"shaft": "MCABlue55",
				"flexes": [{ "name": "R2", "value": 2 }, { "name": "R", "value": 3 }, { "name": "S", "value": 4 }, { "name": "X", "value": 5 }]
			}
			
		],
		"GTS": [{
				"shaft": "MCARedRIP45",
				"flexes": [{ "name": "R3", "value": 1 }]
			},
			{
				"shaft": "MCARedRIP55",
				"flexes": [{ "name": "R2", "value": 2 }, { "name": "R", "value": 3 }, { "name": "S", "value": 4 }]
			},
			{
				"shaft": "MCABlueRIP55",
				"flexes": [{ "name": "R2", "value": 2 }, { "name": "R", "value": 3 }, { "name": "S", "value": 4 }, { "name": "X", "value": 5 }]
			},
			{
				"shaft": "MCABlueRIP65",
				"flexes": [{ "name": "R", "value": 3 }, { "name": "S", "value": 4 }, { "name": "X", "value": 5 }]
			},
			{
				"shaft": "ProjX60",
				"flexes": [{ "name": "5.5", "value": 3 }, { "name": "6.0", "value": 4 }, { "name": "6.5", "value": 5 }]
			},
			{
				"shaft": "ProjX70",
				"flexes": [{ "name": "5.5", "value": 3 }, { "name": "6.0", "value": 4 }, { "name": "6.5", "value": 5 }]
			},
			{
				"shaft": "MCAWhiteRIP65",
				"flexes": [{ "name": "S", "value": 4 }, { "name": "X", "value": 5 }]
			},
			{
				"shaft": "MCAWhiteRIP75",
				"flexes": [{ "name": "S", "value": 4 }, { "name": "X", "value": 5 }]
			}]
	};

	let locale = document.querySelector('html').getAttribute("lang");

	this.defaultShafts = {
		"GT1": { "shaft": "ProjX50", "flex": "5.0" },
		"GTS2": { "shaft": "MCABlueRIP55", "flex": "R" },
		"GTS3": { "shaft": "ProjX60", "flex": "6.0" },
		"GTS4": { "shaft": "MCAWhiteRIP65", "flex": "X" }
	}

	if (locale == 'jp') {
		let gtsShafts = this.shaftMatrix['GTS'];

		gtsShafts = gtsShafts.filter(shaft => shaft.shaft !== 'ProjX60' && shaft.shaft !== 'ProjX70');
		this.shaftMatrix['GTS'] = gtsShafts;

		this.defaultShafts['GTS3'] = { "shaft": "MCAWhiteRIP65", "flex": "X" };
	} 

	this.adjustmentMatrix = {
		"distances": [{
			"min": 0,
			"max": 2,
			"trajectories": [{
				"min": 0,
				"max": 2,
				"performances": [{
					"min": 0,
					"max": 10,
					"loftAdj": 1,
					"shaftAdj": -2,
					
					}]
			}, {
					"min": 3,
					"max": 7,
					"performances": [{
						"min": 0,
						"max": 10,
						"loftAdj": 1,
						"shaftAdj": 0
						
					}]
				}, {
					"min": 8,
					"max": 10,
					"performances": [{
						"min": 0,
						"max": 10,
						"loftAdj": 0,
						"shaftAdj": 2,
						
					}]
				}]
		}, {
				"min": 3,
				"max": 7,
				"trajectories": [{
					"min": 0,
					"max": 2,
					"performances": [{
						"min": 0,
						"max": 10,
						"loftAdj": 1,
						"shaftAdj": 0
						
					}]
				}, {
					"min": 3,
					"max": 7,
					"performances": [{
						"min": 0,
						"max": 5,
						"loftAdj": 1,
						"shaftAdj": 1
						
					}, {
							"min": 6,
							"max": 10,
							"loftAdj": 0,
							"shaftAdj": 0
							
						}]
				}, {
					"min": 8,
					"max": 10,
					"performances": [{
						"min": 0,
						"max": 5,
						"loftAdj": 0,
						"shaftAdj": 1
						
					}, {
							"min": 6,
							"max": 10,
						"loftAdj": -1,
						"shaftAdj": 0
							
						}]
				}]
			}, {
				"min": 8,
				"max": 10,
				"trajectories": [{
					"min": 0,
					"max": 2,
					"performances": [{
						"min": 0,
						"max": 10,
						"loftAdj": 1,
						"shaftAdj": 0

					}]
				}, {
					"min": 3,
					"max": 7,
					"performances": [{
						"min": 0,
						"max": 5,
						"loftAdj": 1,
						"shaftAdj": 1

					}, {
						"min": 6,
						"max": 10,
						"loftAdj": 0,
						"shaftAdj": 0

					}]
				}, {
					"min": 8,
					"max": 10,
					"performances": [{
						"min": 0,
						"max": 5,
						"loftAdj": 0,
						"shaftAdj": 1

					}, {
						"min": 6,
						"max": 10,
						"loftAdj": -1,
						"shaftAdj": 0

					}]
				}]
			}]
	};

	if (locale == 'kr') {
		this.adjustmentMatrix = {
			"distances": [{
				"min": 0,
				"max": 2,
				"trajectories": [{
					"min": 0,
					"max": 2,
					"performances": [{
						"min": 0,
						"max": 10,
						"loftAdj": 1,
						"shaftAdj": -1,
					
						}]
				}, {
					"min": 3,
					"max": 7,
					"performances": [{
						"min": 0,
						"max": 10,
						"loftAdj": 1,
						"shaftAdj": 0
						
					}]
				}, {
					"min": 8,
					"max": 10,
					"performances": [{
						"min": 0,
						"max": 10,
						"loftAdj": 0,
						"shaftAdj": 1,
						
					}]
				}]
		}, {
				"min": 3,
				"max": 7,
				"trajectories": [{
					"min": 0,
					"max": 2,
					"performances": [{
						"min": 0,
						"max": 10,
						"loftAdj": 1,
						"shaftAdj": 1
						
					}]
				}, {
					"min": 3,
					"max": 7,
					"performances": [{
						"min": 0,
						"max": 5,
						"loftAdj": 1,
						"shaftAdj": 0
						
					}, {
							"min": 6,
							"max": 10,
							"loftAdj": 0,
							"shaftAdj": 0
							
						}]
				}, {
					"min": 8,
					"max": 10,
					"performances": [{
						"min": 0,
						"max": 5,
						"loftAdj": 0,
						"shaftAdj": 0
						
					}, {
							"min": 6,
							"max": 10,
						"loftAdj": -1,
						"shaftAdj": 0
							
						}]
				}]
			}, {
				"min": 8,
				"max": 10,
				"trajectories": [{
					"min": 0,
					"max": 2,
					"performances": [{
						"min": 0,
						"max": 10,
						"loftAdj": 1,
						"shaftAdj": 0

					}]
				}, {
					"min": 3,
					"max": 7,
					"performances": [{
						"min": 0,
						"max": 5,
						"loftAdj": 1,
						"shaftAdj": 0

					}, {
						"min": 6,
						"max": 10,
						"loftAdj": 0,
						"shaftAdj": 0

					}]
				}, {
					"min": 8,
					"max": 10,
					"performances": [{
						"min": 0,
						"max": 5,
						"loftAdj": 0,
						"shaftAdj": 0

					}, {
						"min": 6,
						"max": 10,
						"loftAdj": -1,
						"shaftAdj": 0

					}]
				}]
			}]
		};
		this.shaftMatrix =
	{
		"GT1": [
			{
				"shaft": "BassaraWhite35",
				"flexes": [{"name": "L", "value": 1 }]
			},
			{
				"shaft": "BassaraWhite40",
				"flexes": [{ "name": "R", "value": 2 }]
			},
			{
				"shaft": "FujiNext",
				"flexes": [{ "name": "R", "value": 3 }]
			}			
		],
		"GTS": [{
				"shaft": "MCARedRIP45",
				"flexes": [{ "name": "R3", "value": 3 }]
			},
			{
				"shaft": "MCARedRIP55",
				"flexes": [{ "name": "R", "value": 3 }]
			},
			{
				"shaft": "MCABlueRIP55",
				"flexes": [{ "name": "S", "value": 4 }]
			},
			{
				"shaft": "MCAWhiteRIP65",
				"flexes": [{ "name": "S", "value": 4 }]
			}]
	};

		this.defaultShafts = {
			"GT1": { "shaft": "BassaraWhite40", "flex": "R" },
			"GTS2": { "shaft": "MCARedRIP55", "flex": "R" },
			"GTS3": { "shaft": "MCABlueRIP55", "flex": "S" },
			"GTS4": { "shaft": "MCAWhiteRIP65", "flex": "S" }
		}
	}

	if(document.querySelector('#results-clubs')) {
	let resultsClubs = document.querySelector('#results-clubs').value;

	let clubs = JSON.parse(resultsClubs);

	Object.keys(clubs).forEach(key => {
		console.log(key);           // "name", "age", "role"
		console.log(clubs[key]);     // "Alex", 28, "Developer"


	});
	}



	this.preloaderClosed = function () {
		this.intro.open()
		this.currentState = "intro"
		window.resizeFrame()
	}

	this.introClosed = function () {
		this.scrollToTopOfPage()
		this.currentState = "question"
		this.currentQuestion = 1
		this.question1.open()
		window.resizeFrame()
	}

	this.questionClosed = function (direction) {
		if (direction > 0) {
			// next question or results
			this.currentQuestion++
		} else {
			// previous question or intro
			this.currentQuestion--
		}
		this.scrollToTopOfPage()
		if (this.currentQuestion === 0) {
			this.intro.open()
			window.resizeFrame()
		} else if (this.currentQuestion === this.totalQuestions + 1) {
			//show results
			this.results.open()
			this.currentState = "results"
			window.resizeFrame()
		} else {
			this.questions[this.currentQuestion - 1].open()
		}
	}

	this.storeAnswer = function (answerId) {
		this.answers[this.currentQuestion - 1] = answerId
		//console.log('history is ', this.answers);
		// just to help see progress
		var trash = this.calculateResults()
	}

	this.applyScore = function (questionId, score) {
		this.questionScores[questionId] = parseInt(score);
		console.log('score for ' + questionId + '=' + score);

		switch (questionId) {
			case "question-5":
				this.answers.distance = score;
				break;
			case "question-6":
				this.answers.trajectory = score;
				break;
			case "question-7":
				this.answers.tempo = score;
				break;
			case "question-9":
				this.answers.performance = score;
				break;
		}

		// just to help see progress
		var trash = this.calculateResults()
	}

	this.setLoft = function (loft) {
		var loftVal = loft.replace('&deg;', '');
		var slashIndex = loft.indexOf('/');
		if (slashIndex > -1) {
			loftVal = loftVal.substr(0, slashIndex);
		}

		this.answers.loft = loftVal;
	}

	this.setHandedness = function (hand) {
		
		this.answers.handedness = hand;
	}

	this.getTotalScore = function () {
		let totalScore = 0;

		for (let key in this.questionScores) {
			if (this.questionScores.hasOwnProperty(key)) {
				totalScore += this.questionScores[key];
			}
		}

		console.log('total score =' + totalScore);

		return totalScore;
	}

	this.calculateResults = function () {
		let totalScore = this.getTotalScore();


		let sortedScores = [], primaryScores = [], alternativeScores = [];
		this.matrix.forEach(function (obj) {
			if (totalScore >= obj.min && totalScore <= obj.max) {
				primaryScores.push(obj);
			}
		})

		if (primaryScores.length > 1) {
			sortedScores = this.sortByTiebreaker(primaryScores);
		} else {
			this.matrix.forEach(function (obj) {

				if (primaryScores.length == 1) {
					if (primaryScores[0].id == obj.id) {
						return;
					}
				}

				let diffFromMin = Math.abs(obj.min - totalScore);
				let diffFromMax = Math.abs(obj.max - totalScore);

				let diff = Math.min(diffFromMin, diffFromMax);
				obj.diff = diff;
				if (alternativeScores.length == 0) {
					alternativeScores.push(obj);
				} else {
					if (obj.diff < alternativeScores[0].diff) {
						alternativeScores[0] = obj;

						if (alternativeScores.length > 1) {
							alternativeScores.splice(1, alternativeScores.length - 1);
						}
					} else if (obj.diff == alternativeScores[0].diff) {
						alternativeScores.push(obj);
					}
				}


			})

			if (primaryScores.length == 1) {
				sortedScores.push(primaryScores[0]);

				if (alternativeScores.length > 0) {
					if (alternativeScores.length > 1) {
						alternativeScores = this.sortByTiebreaker(alternativeScores);

					}

					sortedScores.push(alternativeScores[0]);
				}

			} else {
				if (alternativeScores.length > 0) {
					if (alternativeScores.length > 1) {
						alternativeScores = this.sortByTiebreaker(alternativeScores);

					}
					sortedScores.push(...alternativeScores);
				}
			}
		}

		//if we only have one result, add a second one that is different
		if (sortedScores.length == 1) {
			let otherOptions = this.matrix.filter(d => d.id != sortedScores[0].id);
			sortedScores.push(otherOptions[0]);
		}

		return sortedScores;
	}

	this.getShaft = function (model) {


		let shaft = this.defaultShafts[model].shaft;
		console.log('shaft=' + shaft);

		let shaftAdjVal = this.getShaftAdjustmentValue();
		console.log('getShaftAdjustmentValue=' + shaftAdjVal);

		if (shaftAdjVal != 0) {
			let modelIndex = this.getModelIndex(model);
			let curIndex = -1;

			curIndex = this.getShaftIndex(model, shaft);

			if (curIndex > -1) {
				let newIndex = curIndex + shaftAdjVal;
				console.log('new index=' + newIndex);
				if (newIndex >= 0 && newIndex < this.shaftMatrix[modelIndex].length) {
					shaft = this.shaftMatrix[modelIndex][newIndex].shaft;
					console.log('new shaft=' + shaft);
				}
			}

		}

		return shaft;
	}

	this.getModelIndex = function (model) {
		let modelIndex = model;
		if (modelIndex.indexOf("GTS") > -1) {
			modelIndex = "GTS";
		}

		return modelIndex;

	}

	this.getShaftIndex = function (model, shaft) {
		let modelIndex = this.getModelIndex(model);
		let defaultIndex = this.shaftMatrix[modelIndex].findIndex(m => m.shaft == shaft);

		/*
		for (let y = 0; y < this.shaftMatrix[modelIndex].length; y++) {
			if (this.shaftMatrix[modelIndex][y].shaft == shaft) {
				console.log('default shaft index=' + y);
				defaultIndex = y;
				break;
			}
		}*/	

		return defaultIndex;
	}


	this.getShaftAdjustmentValue = function () {
		let shaftAdjVal = 0;

		let dist = self.adjustmentMatrix.distances.find(d => self.answers.distance >= d.min && self.answers.distance <= d.max)

		if (dist) {
			let traj = dist.trajectories.find(t => self.answers.trajectory >= t.min && self.answers.trajectory <= t.max)
			if (traj) {
				let perf = traj.performances.find(p => self.answers.performance >= p.min && self.answers.performance <= p.max);
				shaftAdjVal = perf.shaftAdj;
			}
		}


		return shaftAdjVal;
	}

	this.getRecFlex = function (model, recShaft) {
		let flexAdj = 0;
		if (this.answers.tempo <= 2) {
			flexAdj = -1;
		} else if (this.answers.tempo >= 8) {
			flexAdj = 1;
		}

		console.log('flexAdj=' + flexAdj);

		let defaultFlex = this.defaultShafts[model].flex;
		let defaultShaft = this.defaultShafts[model].shaft;
		let modelIndex = this.getModelIndex(model);
		let defaultShaftIndex = this.getShaftIndex(model, defaultShaft);
		let recShaftIndex = this.getShaftIndex(model, recShaft);
		let flexValue = -1;
		let defaultFlexValue = -1;
		let recFlex = '';
		//for (let x = 0; x < this.shaftMatrix[modelIndex][defaultShaftIndex].flexes; x++) {
		//	if (this.shaftMatrix[modelIndex][defaultShaftIndex].flexes[x].name == defaultFlex) {
		//		flexValue = this.shaftMatrix[modelIndex][defaultShaftIndex].flexes[x].value;
		//	}
		//}

		let defaultFlxObj = this.shaftMatrix[modelIndex][defaultShaftIndex].flexes.find(f => f.name == defaultFlex);

		if (defaultFlxObj) {
			defaultFlexValue = defaultFlxObj.value;
			console.log('defaultFlexValue=' + defaultFlexValue);
		}

		flexValue = defaultFlexValue + flexAdj;

		console.log('adjFlexValue=' + flexValue);

		let recFlxObj = this.shaftMatrix[modelIndex][recShaftIndex].flexes.find(f => f.value == flexValue);

		if (recFlxObj) {
			console.log('recFlex found=' + recFlxObj.name);
			recFlex = recFlxObj.name;
		} else {
			console.log('recFlex not found');
			recFlxObj = this.shaftMatrix[modelIndex][recShaftIndex].flexes.find(f => f.value == defaultFlexValue);
			if (recFlxObj) {
				console.log('defFlex found=' + recFlxObj.name);
				recFlex = recFlxObj.name;
			} else {
				recFlxObj = this.shaftMatrix[modelIndex][recShaftIndex].flexes[0];
				console.log('defFlex not found. 1st flex =' + recFlxObj.name);
				recFlex = recFlxObj.name;
			}
		}

		return recFlex;
	}

	this.getRecLoft = function (model) {
		let loftAdj = self.getLoftAdjustmentValue();
		console.log('origloft=' + self.answers.loft);
		console.log('loftAdj=' + loftAdj);
		let loftVal = parseInt(self.answers.loft) + loftAdj;
		console.log('new loftVal=' + loftVal);
		let loftOpts = document.querySelector('[name="' + model + '-compare-lofts"]').value.split(',');

		let found = loftOpts.find(l => parseInt(l) == parseInt(loftVal));

		if (!found) {
			console.log('new loftVal not found');
			found = loftOpts.find(l => parseInt(l) == parseInt(self.answers.loft));
		}

		if (found) {
			loftVal = found;
		} else {
			console.log('orig loft not found');
			let maxLoft = Math.max(loftOpts);
			let minLoft = Math.min(loftOpts);
			if (maxLoft < parseInt(loftVal)) {
				loftVal = maxLoft;
			} else {
				loftVal = minLoft;
			}
		}


		return loftVal;
	}

	this.getLoftAdjustmentValue = function () {
		let loftAdjVal = 0;

		let dist = self.adjustmentMatrix.distances.find(d => self.answers.distance >= d.min && self.answers.distance <= d.max)

		if (dist) {
			let traj = dist.trajectories.find(t => self.answers.trajectory >= t.min && self.answers.trajectory <= t.max)
			if (traj) {
				let perf = traj.performances.find(p => self.answers.performance >= p.min && self.answers.performance <= p.max);
				loftAdjVal = perf.loftAdj;
			}
		}


		return loftAdjVal;
	}

	this.sortByTiebreaker = function (scores) {
		let sorted = [];
		scores.forEach(function (obj) {
			sorted.push(obj);
		})

		return sorted;
	}

	this.getMPI = function (clubId) {
		let mpi = 0;

		let totalScore = this.getTotalScore();

		this.matrix.forEach(function (iron) {
			if (iron.id == clubId) {
				let minDiff = Math.abs(totalScore - iron.min);
				let maxDiff = Math.abs(totalScore - iron.max);

				let diff = Math.min(minDiff, maxDiff);

				mpi = Math.round(98 - diff);
			}
		});

		return mpi
	}

	this.restart = function () {
		this.results.exit()
	}

	this.reset = function () {
		this.resetProgressBar()
		this.hideProgressBar()
		this.currentQuestion = 0
		this.intro.open()
		this.currentState = "intro"
		window.resizeFrame()
		this.scrollToTopOfPage()
		this.questions.forEach(function (question) {
			question.reset()
		}) 
	}


	this.scrollToTopOfPage = function () {
		try {
			window.scrollTo({
				top: 0,
				behavior: "auto"
			})
		} catch (e) {
			console.log("scroll to top error")
		}
		try {
			window.parent.postMessage(["scrollToTop"], "*")
		} catch (e) {
			console.log("scroll to top error")
		}
	}

	this.fillProgressBar = function () {
		//let direction = this.currentQuestion >= this.progressIndex ? 1 : -1
		if (this.currentQuestion > 0) {
			self.progressBar.show();
		}
		self.progressIndex = this.currentQuestion - 1;
		self.progressBar.setProgress(this.progressIndex, this.totalQuestions);
	}

	this.clearProgressBar = function (direction) {
		self.progressBar.setProgress(0, this.totalQuestions);
	}

	this.hideProgressBar = function () {
		self.progressBar.hide();
		self.progressBar.setProgress(0, this.totalQuestions);
	}

	this.completeProgressBar = function () {
		self.progressBar.setProgress(this.totalQuestions, this.totalQuestions);
	}

	this.resetProgressBar = function () {
		self.progressBarSegments.forEach(function (el) {
			el.classList.add("no-animate")
			el.clientHeight
			el.classList.remove("is-complete")
			el.classList.remove("is-active")
			el.clientHeight
			el.classList.remove("no-animate")
		})
		self.progressIndex = 0;
		self.progressBar.setProgress(this.progressIndex, this.totalQuestions);
	}

	this.getHeight = function () {
		let height = 800;
		let width = window.innerWidth;
		let body = document.body;
		let main = document.getElementById('main');

		height = main.clientHeight;

		return height
	}

}

Application.prototype.VALUES = {
	next: null,
	shortcut: null,
	analyticsQuestion: null,
	analyticsAnswer: null,
	weightAmount: null,
	weightIds: null,
	color: null,
	scores: {},
	products: []
}

export default Application
